import { render, staticRenderFns } from "./OrderModalList.vue?vue&type=template&id=2a174aa2&scoped=true&"
import script from "./OrderModalList.vue?vue&type=script&lang=ts&"
export * from "./OrderModalList.vue?vue&type=script&lang=ts&"
import style0 from "./OrderModalList.vue?vue&type=style&index=0&id=2a174aa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a174aa2",
  null
  
)

export default component.exports